import { useEffect, useState } from 'react';
import { useAppState } from '../contexts/appState';
import { handlePopup } from '../reducersAndActions/actions/appStateActions';

export default function usePopup() {
  const [appState, appDispatch] = useAppState();
  const { popupObj } = appState;
  const [popup, setPopup] = useState(popupObj?.open ? { ...popupObj } : {});

  useEffect(() => {
    handlePopup(appDispatch, {
      open: popup?.open || false,
      popupType: popup?.popupType || '',
      heading: popup?.heading || '',
      subHeading: popup?.subHeading || '',
      placeholder: popup?.placeholder || '',
    });
  }, [popup]);

  return [setPopup];
}
